import { createSlice } from '@reduxjs/toolkit';
import { editClinicApi } from '../../../rtk-apis/clinics/editClinic';

const initialState = {
  status: '',
  result: null,
  msg: '',
  loading: false,
  error: '',
};

const editClinicApiSlice = createSlice({
  name: 'editClinicApiSlice',
  initialState,
  reducers: {
    clearState: state => {
      state.status = '';
      state.result = null;
      state.msg = '';
      state.loading = false;
      state.error = '';
    },
  },
  extraReducers: builder => {
    builder
      .addCase(editClinicApi.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(editClinicApi.fulfilled, (state, action) => {
        state.loading = false;
        state.status = 'SUCCESS';
        state.result = action?.payload;
        state.msg = action?.payload?.msg;
      })
      .addCase(editClinicApi.rejected, (state, action) => {
        state.loading = false;
        state.status = 'ERROR';
        state.result = null;
        state.msg = (action?.payload as string) || 'Something went wrong!';
      });
  },
});

export default editClinicApiSlice.reducer;
export const { clearState } = editClinicApiSlice.actions;
